import moment from "moment";
import {
  useGetCurrentCommissionRateForEmailQuery,
  useGetMyCurrentCommissionRateQuery,
} from "api/rtkQueryApi/CommissionsApi";

export const useGetCurrentCommissionRate = (
  forMonth: moment.Moment,
  selectedUser?: string,
) => {
  const {
    data: commissionRatesForEmail,
    isFetching: commissionRatesForEmailIsFetching,
  } = useGetCurrentCommissionRateForEmailQuery(
    {
      email: selectedUser ?? "",
      forMonth: forMonth,
    },
    {
      skip: !selectedUser || !forMonth,
    },
  );

  const { data: myCommissionRates, isFetching: myCommissionRatesIsFetching } =
    useGetMyCurrentCommissionRateQuery(
      {
        forMonth: forMonth,
      },
      {
        skip: !!selectedUser || !forMonth,
      },
    );

  if (selectedUser) {
    return {
      commissionRates: commissionRatesForEmail,
      commissionRatesIsFetching: commissionRatesForEmailIsFetching,
    };
  }

  return {
    commissionRates: myCommissionRates,
    commissionRatesIsFetching: myCommissionRatesIsFetching,
  };
};
